export const NEW_OTP_REQUIRED_MESSAGE = 'New OTP is required';
export const D_614 = 'D_614';
